import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "@lib/icons/types"

export const IconAlert = forwardRef<SVGSVGElement, IconProps>(function IconFire(
  props,
  ref,
) {
  const { className, title, titleId, ...otherProps } = props
  const defaultClasses =
    "w-6 h-6 flex-shrink-0 text-red-400 transition-colors duration-150 ease-in focus:outline-none"
  const classes = mergeClasses(defaultClasses, className)

  return (
    <svg
      ref={ref}
      viewBox="0 0 24 25"
      fill="none"
      focusable="false"
      aria-hidden="true"
      tabIndex={-1}
      className={classes}
      aria-labelledby={titleId}
      {...otherProps}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#clip0_1301_15306)">
        <path
          d="M11.5799 15.178C11.4605 15.178 11.3461 15.1306 11.2617 15.0462C11.1773 14.9618 11.1299 14.8473 11.1299 14.728V7.80547C11.1299 7.68612 11.1773 7.57166 11.2617 7.48727C11.3461 7.40288 11.4605 7.35547 11.5799 7.35547C11.6992 7.35547 11.8137 7.40288 11.8981 7.48727C11.9825 7.57166 12.0299 7.68612 12.0299 7.80547V14.7505C12.0241 14.8659 11.9742 14.9746 11.8904 15.0542C11.8066 15.1338 11.6954 15.1781 11.5799 15.178Z"
          fill="#DD4C28"
        />
        <path
          d="M11.5802 17.9148C11.4208 17.9141 11.2678 17.8524 11.1527 17.7423C11.0423 17.6289 10.9805 17.4769 10.9805 17.3186C10.9805 17.1603 11.0423 17.0082 11.1527 16.8948C11.2085 16.8381 11.275 16.7931 11.3484 16.7624C11.4218 16.7316 11.5006 16.7158 11.5802 16.7158C11.6597 16.7158 11.7385 16.7316 11.8119 16.7624C11.8853 16.7931 11.9518 16.8381 12.0077 16.8948C12.0633 16.9495 12.1073 17.015 12.1369 17.0872C12.1666 17.1593 12.1813 17.2368 12.1802 17.3148C12.1812 17.3939 12.1663 17.4724 12.1365 17.5456C12.1067 17.6189 12.0626 17.6854 12.0067 17.7413C11.9508 17.7972 11.8842 17.8414 11.811 17.8712C11.7377 17.901 11.6592 17.9158 11.5802 17.9148Z"
          fill="#DD4C28"
        />
        <path
          d="M20.4751 23.8253C20.3586 23.8251 20.2427 23.8099 20.1301 23.7803L3.00006 19.1978C2.80768 19.1469 2.62938 19.0529 2.47866 18.923C2.32794 18.7931 2.20873 18.6306 2.13006 18.4478C2.05228 18.2632 2.01728 18.0634 2.02767 17.8634C2.03806 17.6634 2.09358 17.4683 2.19006 17.2928L10.7626 1.85027C10.8842 1.6364 11.0634 1.46101 11.2799 1.34412C11.4964 1.22723 11.7414 1.17354 11.9869 1.18918C12.2325 1.20482 12.4687 1.28915 12.6686 1.43257C12.8685 1.57598 13.0241 1.7727 13.1176 2.00027L21.6751 21.9953C21.7605 22.1944 21.7953 22.4117 21.7764 22.6275C21.7574 22.8434 21.6853 23.0513 21.5665 23.2325C21.4476 23.4137 21.2858 23.5627 21.0953 23.6662C20.9049 23.7696 20.6918 23.8243 20.4751 23.8253ZM11.9101 2.07527C11.8357 2.07423 11.7626 2.09406 11.6989 2.13251C11.6353 2.17096 11.5837 2.22648 11.5501 2.29277L3.00006 17.7503C2.97231 17.8062 2.95786 17.8678 2.95786 17.9303C2.95786 17.9927 2.97231 18.0543 3.00006 18.1103C3.02391 18.1681 3.06061 18.2198 3.10739 18.2614C3.15417 18.303 3.2098 18.3334 3.27006 18.3503L20.3851 22.9328C20.4601 22.9534 20.5395 22.9524 20.614 22.9298C20.6885 22.9072 20.7551 22.864 20.8061 22.8052C20.8571 22.7463 20.8904 22.6743 20.9022 22.5973C20.9139 22.5204 20.9037 22.4416 20.8726 22.3703L12.2926 2.33027C12.2636 2.25752 12.2142 2.19471 12.1503 2.14945C12.0864 2.1042 12.0108 2.07843 11.9326 2.07527H11.9101Z"
          fill="#DD4C28"
        />
      </g>
      <defs>
        <clipPath id="clip0_1301_15306">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
})
